import { render } from "./SeminarList.vue?vue&type=template&id=5ba92e2f&ts=true"
import script from "./SeminarList.vue?vue&type=script&lang=ts"
export * from "./SeminarList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__